"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchProvider = void 0;
const injectors_1 = require("og-core/store/injectors");
const saga_1 = require("./saga");
const slice_1 = require("./slice");
const useSearchProvider = () => {
    // eslint-disable-next-line
    // @ts-expect-error
    (0, injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.searchProviderSaga });
};
exports.useSearchProvider = useSearchProvider;
//# sourceMappingURL=useSearchProvider.js.map